export default "__VITE_ASSET__f977ec3d__"